import type { QuestionPlayerQuestion, SupportedLanguage } from './QuestionPlayer';

type DemoQuestionTranslation = {
  question_text: string;
  answer_a?: string | null;
  answer_b?: string | null;
  answer_c?: string | null;
};

type DemoQuestion = Omit<QuestionPlayerQuestion, 'language' | 'question_text' | 'answer_a' | 'answer_b' | 'answer_c'> & {
  translations: Record<SupportedLanguage, DemoQuestionTranslation>;
};

const PUBLIC_DEMO_QUESTIONS: DemoQuestion[] = [
  {
    id: 'public-demo-99',
    number: 99,
    type: 'TAK_NIE',
    scope: 'PODSTAWOWY',
    points: 3,
    media_file: 'AK_D05_06_org.wmv',
    media_type: 'VIDEO',
    translations: {
      pl: { question_text: 'Czy w tej sytuacji masz obowiązek zatrzymać pojazd?' },
      en: { question_text: 'Are you obliged to stop the vehicle in the presented situation?' },
      de: { question_text: 'Bist du in der dargestellten Situation dazu verpflichtet, das Fahrzeug anzuhalten?' },
      ua: { question_text: "Чи зобов'язані Ви зупинити свій транспортний засіб у цій ситуації?" },
    },
  },
  {
    id: 'public-demo-100',
    number: 100,
    type: 'TAK_NIE',
    scope: 'PODSTAWOWY',
    points: 3,
    media_file: 'AK_D10_30_org.wmv',
    media_type: 'VIDEO',
    translations: {
      pl: { question_text: 'Czy w tej sytuacji masz obowiązek zatrzymać pojazd?' },
      en: { question_text: 'Are you obliged to stop the vehicle in the presented situation?' },
      de: { question_text: 'Sind Sie in der dargestellten Situation dazu verpflichtet, das Fahrzeug anzuhalten?' },
      ua: { question_text: "Чи зобов'язані Ви зупинити свій транспортний засіб у цій ситуації?" },
    },
  },
  {
    id: 'public-demo-109',
    number: 109,
    type: 'TAK_NIE',
    scope: 'PODSTAWOWY',
    points: 3,
    media_file: 'AK_D11_43org.wmv',
    media_type: 'VIDEO',
    translations: {
      pl: { question_text: 'Czy w przedstawionej sytuacji masz prawo kontynuować jazdę?' },
      en: { question_text: 'Can you continue driving in this situation?' },
      de: { question_text: 'Darfst du in der dargestellten Situation die Fahrt fortsetzen?' },
      ua: { question_text: 'Чи Ви маєте право продовжувати рух у представленій ситуації?' },
    },
  },
  {
    id: 'public-demo-110',
    number: 110,
    type: 'TAK_NIE',
    scope: 'PODSTAWOWY',
    points: 3,
    media_file: 'AK_D11_45org.wmv',
    media_type: 'VIDEO',
    translations: {
      pl: { question_text: 'Czy w przedstawionej sytuacji masz prawo - mimo podawanego sygnału - skręcić w prawo?' },
      en: { question_text: 'Are you allowed in this situation to turn right despite the light displayed?' },
      de: { question_text: 'Darfst du in der dargestellten Situation - trotz des gegebenen Signals - rechts abbiegen?' },
      ua: { question_text: 'Чи Ви маєте право у представленій ситуації повертати вправо, незважаючи на сигнал, що подається?' },
    },
  },
  {
    id: 'public-demo-352',
    number: 352,
    type: 'TAK_NIE',
    scope: 'PODSTAWOWY',
    points: 1,
    media_file: 'IMG_4251orgbm.jpg',
    media_type: 'IMAGE',
    translations: {
      pl: { question_text: 'Czy na jezdni oznaczonej tym znakiem wolno Ci zawrócić?' },
      en: { question_text: 'Are you allowed to make a U-turn on a roadway with this sign?' },
      de: { question_text: 'Darfst du auf der mit diesem Zeichen gekennzeichneten Fahrbahn wenden?' },
      ua: { question_text: 'Чи дозволяється розворот Вашого транспортного засобу, якщо проїжджа частина позначена цим знаком?' },
    },
  },
  {
    id: 'public-demo-469',
    number: 469,
    type: 'TAK_NIE',
    scope: 'PODSTAWOWY',
    points: 3,
    media_file: '3106D15_a_org.jpg',
    media_type: 'IMAGE',
    translations: {
      pl: { question_text: 'Czy w tej sytuacji powinieneś oczekiwać, że następnym sygnałem będzie światło zielone?' },
      en: { question_text: 'In the presented situation, should you expect that the next light will be green?' },
      de: { question_text: 'Soll man in der dargestellten Situation erwarten, dass als nächstes Signal das grüne Licht kommt?' },
      ua: { question_text: 'Чи у цій ситуації слід очікувати, що наступним сигналом буде зелене світло світлофора?' },
    },
  },
  {
    id: 'public-demo-475',
    number: 475,
    type: 'TAK_NIE',
    scope: 'PODSTAWOWY',
    points: 3,
    media_file: '0118D14MM_a_org.jpg',
    media_type: 'IMAGE',
    translations: {
      pl: { question_text: 'Czy w tej sytuacji wolno Ci skręcić w prawo bez zatrzymania się przed sygnalizatorem?' },
      en: { question_text: 'In the presented situation are you allowed to turn right without stopping before the traffic lights?' },
      de: { question_text: 'Darf man in der dargestellten Situation rechts abbiegen, ohne vor der Ampel angehalten zu haben?' },
      ua: { question_text: 'Чи можна в цій ситуації повертати вправо, не зупиняючись перед світлофором?' },
    },
  },
  {
    id: 'public-demo-477',
    number: 477,
    type: 'TAK_NIE',
    scope: 'PODSTAWOWY',
    points: 3,
    media_file: '2064D14MM_a_org.jpg',
    media_type: 'IMAGE',
    translations: {
      pl: { question_text: 'Czy w tej sytuacji sygnał świetlny nadawany dla Twojego pasa ruchu zezwala Ci na zawracanie?' },
      en: { question_text: 'Does the light signal for you lane allow for making a U-turn in this situation?' },
      de: { question_text: 'Erlaubt in der dargestellten Situation das Lichtsignal, das für Ihre Fahrspur gesendet wird, zu wenden?' },
      ua: { question_text: 'Чи у цій ситуації сигнал світлофора для Вашої смуги руху дозволяє Вам на розворот транспортного засобу?' },
    },
  },
  {
    id: 'public-demo-478',
    number: 478,
    type: 'TAK_NIE',
    scope: 'PODSTAWOWY',
    points: 3,
    media_file: '066D16_a_org.jpg',
    media_type: 'IMAGE',
    translations: {
      pl: { question_text: 'Czy w tej sytuacji nadawany sygnał świetlny oznacza, że podczas jazdy w prawo nie występuje kolizja z innymi uczestnikami ruchu?' },
      en: { question_text: 'Does the traffic light displayed in this situation denote that when turning right there is no collision with other road users?' },
      de: { question_text: 'Bedeutet das in der dargestellten Situation gegebene Leuchtsignal, dass es bei der Fahrt nach rechts keine Gefahr mehr gibt, mit anderen Verkehrsteilnehmern zu kollidieren?' },
      ua: { question_text: 'Чи у цій ситуації сигнал світлофора означає, що Ви не зіткнетеся з іншими учасниками дорожнього руху, якщо будете повертати вправо?' },
    },
  },
  {
    id: 'public-demo-480',
    number: 480,
    type: 'TAK_NIE',
    scope: 'PODSTAWOWY',
    points: 3,
    media_file: 'IMG_0325_9550d5_a_org.jpg',
    media_type: 'IMAGE',
    translations: {
      pl: { question_text: 'Czy w tej sytuacji nadawany sygnał świetlny zezwala Ci na wjazd za sygnalizator?' },
      en: { question_text: 'Does the traffic light displayed in this situation allow you to drive beyond the traffic light post?' },
      de: { question_text: 'Erlaubt das gegebene Leuchtsignal die Weiterfahrt hinter der Ampel?' },
      ua: { question_text: "Чи дозволяє в цій ситуації сигнал світлофора в'їжджати на перехрестя за світлофор?" },
    },
  },
];

export const PUBLIC_DEMO_QUESTION_LIMIT = PUBLIC_DEMO_QUESTIONS.length;

export function getPublicDemoQuestion(index: number, language: SupportedLanguage): QuestionPlayerQuestion {
  const question = PUBLIC_DEMO_QUESTIONS[index] ?? PUBLIC_DEMO_QUESTIONS[0];
  const translation = question.translations[language] ?? question.translations.pl;

  return {
    id: `${question.id}-${language}`,
    number: question.number,
    type: question.type,
    scope: question.scope,
    points: question.points,
    media_file: question.media_file,
    media_type: question.media_type,
    language,
    question_text: translation.question_text,
    answer_a: translation.answer_a ?? null,
    answer_b: translation.answer_b ?? null,
    answer_c: translation.answer_c ?? null,
  };
}
